import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const adminApi = axios.create({ baseURL: API });

adminApi.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("kobolog_admin_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

/**
 * Iter32 — global 401/403 interceptor.
 * If the admin token has expired, been revoked, or the user no longer has an
 * `admin` role, wipe the local token and bounce the user to /admin/login so
 * pages don't hang on an infinite loading spinner or partial data.
 */
adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    if (status === 401 || status === 403) {
      try { localStorage.removeItem("kobolog_admin_token"); } catch (_) { /* storage disabled */ }
      // Only redirect from inside the admin area (avoid loops on /admin/login).
      if (window.location.pathname.startsWith("/admin") &&
          !window.location.pathname.startsWith("/admin/login")) {
        window.location.assign("/admin/login");
      }
    }
    return Promise.reject(err);
  }
);

export default adminApi;
